import {
  Badge,
  Box,
  Flex,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { MdArrowForward, MdCheck } from "react-icons/md";
import { IconChat, IconVoice } from "../Illustrations";

function ChannelCard({ channel, value, onPick, icon, accent, gradient, title, subtitle, tags }) {
  const selected = value === channel;
  return (
    <Box
      role="group"
      cursor="pointer"
      onClick={() => onPick(channel)}
      borderRadius="xl"
      overflow="hidden"
      position="relative"
      bg="white"
      borderWidth="2px"
      borderColor={selected ? `${accent}.400` : "gray.200"}
      transition="all 0.2s ease"
      _hover={{
        transform: "translateY(-4px)",
        shadow: "xl",
        borderColor: `${accent}.300`,
      }}
    >
      <Box bgGradient={gradient} h="6px" w="100%" />
      <Box p={5}>
        <Flex align="center" justify="space-between" mb={3}>
          <Flex
            w="56px"
            h="56px"
            borderRadius="lg"
            bgGradient={gradient}
            align="center"
            justify="center"
            shadow="md"
            transition="transform 0.2s ease"
            _groupHover={{ transform: "scale(1.05)" }}
          >
            {icon}
          </Flex>
          <Flex
            w="36px"
            h="36px"
            borderRadius="full"
            bg={selected ? `${accent}.500` : `${accent}.50`}
            color={selected ? "white" : `${accent}.500`}
            align="center"
            justify="center"
            transition="all 0.2s ease"
            _groupHover={{ bg: `${accent}.500`, color: "white" }}
          >
            <Icon as={selected ? MdCheck : MdArrowForward} boxSize={5} />
          </Flex>
        </Flex>
        <Heading size="md" mb={1} color="gray.800">
          {title}
        </Heading>
        <Text fontSize="sm" color="gray.600" mb={4}>
          {subtitle}
        </Text>
        {tags?.length > 0 && (
          <HStack spacing={1} flexWrap="wrap">
            {tags.map((t) => (
              <Badge
                key={t}
                colorScheme={accent}
                variant="subtle"
                fontSize="0.65rem"
                textTransform="none"
                fontWeight="500"
                px={2}
                py="2px"
                borderRadius="full"
              >
                {t}
              </Badge>
            ))}
          </HStack>
        )}
      </Box>
    </Box>
  );
}

export default function Step1Channel({ value, onPick }) {
  return (
    <VStack spacing={6} align="stretch">
      <VStack spacing={1} textAlign="center">
        <Heading size="lg">Pick a channel</Heading>
        <Text color="gray.600">Where will your agent talk to people?</Text>
      </VStack>
      <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
        <ChannelCard
          channel="chat"
          value={value}
          onPick={onPick}
          icon={<IconChat size={32} color="#fff" />}
          accent="blue"
          gradient="linear(135deg, #3B82F6 0%, #2563EB 100%)"
          title="Chat"
          subtitle="Embed on your website or in-app"
          tags={["Webpages", "WhatsApp", "Messenger"]}
        />
        <ChannelCard
          channel="voice"
          value={value}
          onPick={onPick}
          icon={<IconVoice size={32} color="#fff" />}
          accent="purple"
          gradient="linear(135deg, #8B5CF6 0%, #6D28D9 100%)"
          title="Voice"
          subtitle="Answer phone calls 24/7"
          tags={["Twilio", "Plivo", "Telnyx", "SIP"]}
        />
      </SimpleGrid>
    </VStack>
  );
}
